/**
 * @title ccpa.js: Feature level module
 * @description The module used for 'ccpa'
 * feature which encapsulates the ccpa functionality.
 */
define(['DNSMIHelper', 'DSRHelper'],
  function(DNSMIHelper, DSRHelper) {
    /**
     * [init description]
     * @return {void} [description]
     */
    function init() {
    	DNSMIHelper.init();
    	DSRHelper.init();
    	
    }
    if (typeof window.COSTCO == 'undefined') {
      window.COSTCO = {};
    }
    if (typeof window.COSTCO.Global == 'undefined') {
      document.addEventListener('CostcoGlobalLoaded', init, false);
    } else {
      init();
    }
  });



// WEBPACK FOOTER //
// ./js/ccpa/ccpa.js